import { MotionReveal } from '@/components/common/MotionReveal';
import { ZoomableImage } from '@/components/common/ImageLightbox';
import { SectionTitle } from '@/components/common/SectionTitle';

const gallery = [
  {
    src: 'https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1400&q=85',
    alt: 'Otvoren poslovni prostor firme',
    className: 'md:col-span-2 md:row-span-2'
  },
  {
    src: 'https://images.unsplash.com/photo-1524758631624-e2822e304c36?auto=format&fit=crop&w=1000&q=85',
    alt: 'Tim u savremenoj kancelariji',
    className: ''
  },
  {
    src: 'https://images.unsplash.com/photo-1517048676732-d65bc937f952?auto=format&fit=crop&w=1000&q=85',
    alt: 'Radionica i razmena ideja',
    className: ''
  },
  {
    src: 'https://images.unsplash.com/photo-1522071901873-411886a10004?auto=format&fit=crop&w=1000&q=85',
    alt: 'Kolege tokom timskog sastanka',
    className: ''
  },
  {
    src: 'https://images.unsplash.com/photo-1497366412874-3415097a27e7?auto=format&fit=crop&w=1000&q=85',
    alt: 'Detalj modernog prostora za sastanke',
    className: ''
  }
];

export function GallerySection() {
  return (
    <section className="border-t border-border bg-surface-muted py-18 sm:py-24 lg:py-30">
      <div className="site-container">
        <SectionTitle
          eyebrow="Iza kulisa"
          title="Radni prostor i sastanci sa timovima."
          description="Fotografije su privremeni prikaz galerije do unosa finalnih fotografija firme, projekata i saradnika."
        />
        <div className="mt-10 grid auto-rows-[220px] gap-3 sm:grid-cols-2 md:grid-cols-4 md:auto-rows-[190px] lg:mt-14 lg:auto-rows-[220px]">
          {gallery.map((image, index) => (
            <MotionReveal
              key={image.src}
              delay={index * 0.045}
              className={`overflow-hidden rounded-[var(--radius-sm)] ${image.className}`}
            >
              <ZoomableImage
                wrapperClassName="h-full"
                className="h-full w-full object-cover"
                src={image.src}
                alt={image.alt}
                loading="lazy"
              />
            </MotionReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
